import { handleActions } from "redux-actions";
import _ from "lodash";
import { WORKING_ORDER } from "constants/action-types";
import { initialBaseState, fetchActions, IFetchStoreState, type IResponse } from "../base-reducers";
import { IProduct } from "types/product";

export interface IWorkingProducts {
    [key: string]: IProduct;
}

interface IWorkingProductsFetchState extends IFetchStoreState<IWorkingProducts> {
    isFetching: boolean;
}

export const products = handleActions<IWorkingProductsFetchState>(
    {
        ...fetchActions(WORKING_ORDER.PRODUCTS.FETCH),
        [WORKING_ORDER.PRODUCTS.RESET]: () => initialBaseState,
        [WORKING_ORDER.PRODUCTS.FETCH.COMPLETE]: (state: IWorkingProductsFetchState) => ({
            ...state,
            isFetching: false,
        }),
        [WORKING_ORDER.PRODUCTS.FETCH.SUCCESS]: (
            state: IWorkingProductsFetchState,
            { payload: list = [], meta }: IResponse<IProduct[]>,
        ) => ({
            ...state,
            payload: { ...state.payload, ..._.keyBy(list, "_id") },
            meta,
            error: null,
            isFetching: false,
        }),
    } as any,
    initialBaseState,
);
